/**
 * MascaraTransportadorSacPublico
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {MascaraTransportadorSacPublicoCollection} from '@/model/collection/MascaraTransportadorSacPublicoCollection'

/* TODO: review generated class */
export class MascaraTransportadorSacPublico extends Resource {
  idMascaraTransportadorSacPublicoPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  ativo: boolean | null = null
  idResponsavelMascaraFk: number | null = null

  get $id() {
    return this.idMascaraTransportadorSacPublicoPk
  }
  set $id(val) {
    this.idMascaraTransportadorSacPublicoPk = val
  }

  /**
   * Gets a instance of a given ID of MascaraTransportadorSacPublico
   */
  async getMascaraTransportadorSacPublico(id: number) {
    return await Request.get(`/admin/mascara-transportador-sac-publico/${id}`)
      .name('getMascaraTransportadorSacPublico')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of MascaraTransportadorSacPublico
   */
  async removeMascaraTransportadorSacPublico() {
    return await Request.delete(
      `/admin/mascara-transportador-sac-publico/${this.$id}`
    )
      .name('removeMascaraTransportadorSacPublico')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of MascaraTransportadorSacPublico
   */
  static async listMascaraTransportadorSacPublico(params: any) {
    return await Request.get(`/admin/mascara-transportador-sac-publico`, {
      params,
    })
      .name('listMascaraTransportadorSacPublico')
      .as(MascaraTransportadorSacPublicoCollection)
      .getData()
  }

  /**
   * Persists a new instance of MascaraTransportadorSacPublico. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistMascaraTransportadorSacPublico() {
    return await Request.post(`/admin/mascara-transportador-sac-publico`, this)
      .name('persistMascaraTransportadorSacPublico')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of MascaraTransportadorSacPublico to use it in a CSV file
   */
  static async listCsvMascaraTransportadorSacPublico(params: any) {
    return await Request.get(`/admin/mascara-transportador-sac-publico/csv`, {
      params,
    })
      .name('listCsvMascaraTransportadorSacPublico')
      .as(MascaraTransportadorSacPublicoCollection)
      .getData()
  }
}
